/**
 * useHelpSearch Hook
 *
 * Purpose: Search help articles with debounced query
 * Created: March 24, 2026
 */

import { useQuery } from '@tanstack/react-query';
import { HelpService } from '../services/HelpService';

export const useHelpSearch = (
  query: string,
  app?: string,
): ReturnType<typeof useQuery> => {
  const trimmed = query.trim();

  return useQuery({
    queryKey: ['help-search', trimmed, app],
    queryFn: async () => {
      const results = await HelpService.searchArticles(trimmed, app);
      // Track the search term (fire and forget)
      if (trimmed.length >= 3) {
        HelpService.trackSearch(trimmed);
      }
      return results;
    },
    enabled: trimmed.length >= 2,
    staleTime: 2 * 60 * 1000,
  });
};
